import { useQueryClient, useMutation } from 'react-query'
import { Auth } from '@aws-amplify/auth'
import { createUserContactPreferences } from '../../../graphql/mutations'
import { CURRENT_USER_KEY, USER_LIST_KEY } from '.'
import {
  CreateUserContactPreferencesMutationVariables as Variables,
  CreateUserContactPreferencesMutation as Response
} from '../../../API'
import { api } from '../../gql-client'
import { useDispatch } from 'react-redux'
import { updateUserInfo } from '../../../redux'

export const useCreateUserContactPreferences = () => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  return useMutation(
    (variables: Variables) => {
      return api.request<Response>({
        query: createUserContactPreferences,
        variables
      })
    },
    {
      onSuccess: async () => {
        queryClient.invalidateQueries(USER_LIST_KEY)
        queryClient.invalidateQueries(CURRENT_USER_KEY)

        const newUser = await Auth.currentAuthenticatedUser({
          bypassCache: true
        })
        dispatch(updateUserInfo(newUser))
      }
    }
  )
}
